import { Typography } from '@common/styles';

import { Clothes } from '../components/international-size-guide/Clothes';
import { Shoes } from '../components/international-size-guide/Shoes';
import { SizeGuide } from '../components/international-size-guide/SizeGuide';
import { TabType, useSizeGuideService } from '../services/useSizeGuideService';

export const InternationalSizeGuideContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { tabList, currentTab, setCurrentTab } = useSizeGuideService();

  return (
    <SizeGuide>
      <SizeGuide.Header>
        <SizeGuide.Title className={Typography.BODY_18_SEMIBOLD}>
          사이즈 가이드
        </SizeGuide.Title>
        <SizeGuide.Subtitle className={Typography.BODY_14_REGULAR}>
          일반적인 사이즈 정보를 기준으로 제공하는 내용입니다. 사이즈 표는 참고용이므로 정확한 사이즈는 실측 정보를 확인해주세요.
        </SizeGuide.Subtitle>
      </SizeGuide.Header>
      <SizeGuide.TabBar>
        {tabList.map(({ tab_type, label }) => {
          return (
            <SizeGuide.TabBarItem
              key={tab_type}
              active={tab_type === currentTab}
              onClick={() => setCurrentTab(tab_type)}
            >
              {label}
            </SizeGuide.TabBarItem>
          );
        })}
      </SizeGuide.TabBar>
      {currentTab === TabType.CLOTHES ? <Clothes /> : null}
      {currentTab === TabType.SHOES ? <Shoes /> : null}
    </SizeGuide>
  );
};
